import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find, get, isArray, map } from 'lodash';

import BankCard from './BankCard';

import styles from './BankCards.module.scss';
import { bankCardProps } from './constants';
import { DeleteCardPopup } from 'modules/Payment/components/BankCards/deleteCardPopup/DeleteCardPopup';
import { ErrorCardPopup } from 'modules/Payment/components/BankCards/ErrorCardPopup/ErrorCardPopup';
import { MODAL_MODE } from 'modules/Payment/components/BankCards/constants';

class BankCards extends Component {
  static getDerivedStateFromProps(nextProps) {
    return {
      keepAddNewCard: nextProps.keepAddNewCard,
    };
  }

  state = {
    modalMode: null,
    keepAddNewCard: false,
    bankCards: PropTypes.arrayOf(bankCardProps),
    processingCard: null,
  };

  componentDidMount() {
    this.props.getBankCards();
    const { bankCards } = this.props;
    const defaultCard = find(bankCards, 'isDefault');
    if (defaultCard) {
      this.props.onSelectCard(defaultCard);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isCardProcessing && prevProps.isCardProcessing !== this.props.isCardProcessing)
      if (this.props.isError) {
        this.openErrorModal();
      } else {
        this.handleCancelModal();
      }
  }

  openErrorModal = () => {
    this.setState({
      modalMode: MODAL_MODE.ERROR,
    });
  };

  handleRemoveCard = (card) => {
    this.setState({
      processingCard: card,
      keepAddNewCard: true,
      modalMode: MODAL_MODE.DELETE,
    });
  };
  handleAcceptRemoveCard = () => {
    this.props.deleteBankCard(this.state.processingCard);
  };
  handleSelectCard = (cardDetails) => {
    const { onSelectCard, isPayment, setDefaultBankCard } = this.props;
    const cardId = cardDetails.id;
    if (!isPayment && cardId) {
      setDefaultBankCard(cardId);
    }
    onSelectCard(cardDetails);
  };
  handleCancelModal = () => {
    this.setState({
      processingCard: null,
      modalMode: false,
    });
  };

  getCardListToRender = () => {
    const { bankCards } = this.props;
    const { keepAddNewCard } = this.state;
    if (!isArray(bankCards)) {
      return [];
    }
    if (bankCards.length > 1 || keepAddNewCard) {
      return bankCards;
    }
    return bankCards.filter((card) => card.id);
  };
  renderBankCards = () => {
    const { selectedCard, isPayment } = this.props;
    const cardsToRender = this.getCardListToRender();
    return map(cardsToRender, (cardDetails) => (
      <BankCard
        key={cardDetails.id}
        onClick={() => this.handleSelectCard(cardDetails)}
        onDelete={() => this.handleRemoveCard(cardDetails.id)}
        cardDetails={cardDetails}
        selected={cardDetails.id === get(selectedCard, 'id')}
        isPayment={isPayment}
      />
    ));
  };

  render() {
    const { modalMode } = this.state;
    return (
      <div className={styles.BankCardsContainer}>
        {this.renderBankCards()}
        {modalMode === MODAL_MODE.DELETE && (
          <DeleteCardPopup
            onOk={this.handleAcceptRemoveCard}
            onCancel={this.handleCancelModal}
            inProcess={this.props.isCardProcessing}
          />
        )}
        {modalMode === MODAL_MODE.ERROR && <ErrorCardPopup onOk={this.handleCancelModal} />}
      </div>
    );
  }
}

BankCards.propTypes = {
  onSelectCard: PropTypes.func,
  getBankCards: PropTypes.func,
  deleteBankCard: PropTypes.func,
  setDefaultBankCard: PropTypes.func,
  selectedCard: PropTypes.shape({
    maskedPan: PropTypes.string,
    id: PropTypes.string,
    recurrent: PropTypes.string,
    isDefault: PropTypes.bool,
  }),
  isCardProcessing: PropTypes.bool,
  isError: PropTypes.bool,
  bankCards: PropTypes.arrayOf(bankCardProps),
  isPayment: PropTypes.bool,
  keepAddNewCard: PropTypes.bool,
};
BankCards.defaultProps = {
  isPayment: true,
};
export default BankCards;
